import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { Push } from '@ionic-native/push';
import { MyApp } from './app.component';
import { HttpModule } from "@angular/http";
import { AnimationService } from "css-animator";
import { Device } from '@ionic-native/device';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule, AngularFireDatabase } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
/********************** providers********************/
import { AuthProvider } from "../providers/authservice/auth";
import { LoginServiceProvider } from "../providers/authservice/loginService";
import { SettingsProvider } from "../providers/settings/settings";
/********************  Components  Here ************************/
import { ListViewComponent } from "../components/list-view/list-view";
import { MultiImageUpload } from "../directives/multiimagesupload/multi-image-upload";
import { CustomepopupComponent } from "../components/customepopup/customepopup";
/********************  Pages Here ************************/
import { HomePage } from '../pages/home/home';
import { LoginPage } from "../pages/login/login";
import { ManagedashboardPage } from "../pages/managedashboard/managedashboard";
import { SpecialsPage } from "../pages/specials/specials";
import { SignupPage } from "../pages/signup/signup";
import { SignupSuccessPage } from "../pages/signup-success/signup-success";
import { WelcomePage } from "../pages/welcome/welcome";
import { WaiterDashboardPage } from "../pages/waiter-dashboard/waiter-dashboard";
//import { WaiterOrdersPage } from "../pages/waiter-orders/waiter-orders";
import { WaiterOrderPage } from "../pages/waiter-order/waiter-order";
//
import { SmartanimationProvider } from '../providers/smartanimation/smartanimation';
import { ResetpasswordPage } from "../pages/resetpassword/resetpassword";
import { SettingsPage } from "../pages/settings/settings";
import { RestaurentserversPage } from "../pages/restaurentservers/restaurentservers";
import { RestaurantslistPage } from "../pages/restaurantslist/restaurantslist";
import { RequestsPage } from "../pages/Requests/Requests";
import { OpenTablesPage } from "../pages/opentables/opentables";

//
//import { LazyLoadImageModule } from "ng-lazyload-image";
import { SpecialsdashboardPage } from "../pages/specialsdashboard/specialsdashboard";
import { CustomerServersPage } from "../pages/customer-servers/customer-servers";
import { CustomerNotificationsPage } from "../pages/customer-notifications/customer-notifications";
import { FilterPipe } from '../pipes/filter/filter';
import { ParallaxHeaderDirective } from "../directives/parallax-header/parallax-header";
import { Ionic2RatingModule } from "ionic2-rating";
import { RegisterPage } from "../pages/register/register";
import { SpiltPanelProvider } from "../providers/spilt-panel/spilt-panel";



const config = {
  apiKey: "AIzaSyDhGdcK7XY7uhZxhF3WuhLCaoP1V7MMIEI",
  authDomain: "resturent-app-e1ac6.firebaseapp.com",
  databaseURL: "https://resturent-app-e1ac6.firebaseio.com",
  projectId: "resturent-app-e1ac6",
  storageBucket: "resturent-app-e1ac6.appspot.com",
  messagingSenderId: "976547392808"
};

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    ParallaxHeaderDirective,
    SpecialsPage,
    MultiImageUpload,
    ManagedashboardPage,
    LoginPage,
    WelcomePage,
    SpecialsdashboardPage,
    SignupPage,
    SignupSuccessPage,
    ResetpasswordPage,
    SettingsPage,
    RestaurentserversPage,
    RestaurantslistPage,
    ListViewComponent,
    CustomerServersPage,
    CustomepopupComponent,
    FilterPipe,
    RegisterPage,
    WaiterDashboardPage,
    //   WaiterOrdersPage,
    WaiterOrderPage,
    RequestsPage,
    CustomerNotificationsPage,
    OpenTablesPage
  ],
  imports: [
    CommonModule,
    BrowserModule,
    Ionic2RatingModule,
    AngularFireModule.initializeApp(config),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    HttpModule,
    IonicModule.forRoot(MyApp)
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    SpecialsPage,
    ManagedashboardPage,
    LoginPage,
    WelcomePage,
    SpecialsdashboardPage,
    SignupPage,
    SignupSuccessPage,
    ResetpasswordPage,
    SettingsPage,
    RestaurentserversPage,
    RestaurantslistPage,
    CustomerServersPage,
    RegisterPage,
    CustomepopupComponent,
    WaiterDashboardPage,
    // WaiterOrdersPage,
    WaiterOrderPage,
    RequestsPage,
    CustomerNotificationsPage,
    OpenTablesPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    SettingsProvider,
    AuthProvider,
    AngularFireDatabase,
    AnimationService,
    SmartanimationProvider,
    Device,
    SpiltPanelProvider,
    LoginServiceProvider,
    Push
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  exports: [
    ListViewComponent,
    CustomepopupComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts